import { getTeamColors } from "components/colors";
export interface XGShot {
  team: "home" | "away";
  x: number; // 0..1
  y: number; // 0..1
  xg: number;
  minute?: number;
  sec?: number;
  player?: string;
  outcome?: string;
  foot?: string;
}

export const clamp = (v: number, lo: number, hi: number) =>
  Math.max(lo, Math.min(hi, v));

export const circleRadius = (xg: number) => clamp(4 + xg * 22, 4, 26);

export function summarize(shots: XGShot[]) {
  const totalXg = shots.reduce((s, it) => s + (it.xg || 0), 0);
  const shotsCount = shots.length;
  const onTarget = shots.filter((s) =>
    (s.outcome || "").toLowerCase().includes("on")
  ).length;
  return { totalXg, shotsCount, onTarget };
}

export const getHomeColor = (status: any) => getTeamColors(status).home;
export const getAwayColor = (status: any) => getTeamColors(status).away;
